import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import React from 'preact/compat'

import { currentAccountId } from './authentication'

function filterSensitiveData(str) {
  return str?.replace(/token=[^&]*/, 'token=[REDACTED]')
}

Bugsnag.start({
  apiKey: import.meta.env.VITE_BUGSNAG_TOKEN,
  plugins: [new BugsnagPluginReact()],
  releaseStage: import.meta.env.MODE,
  metadata: {
    account: {
      id: currentAccountId?.toString(),
    },
  },
  onError: (event) => {
    event.context = filterSensitiveData(event.context)
    event.request.url = filterSensitiveData(event.request.url)
  },
})

const BugsnagErrorBoundary =
  Bugsnag.getPlugin('react')?.createErrorBoundary(React)

export { Bugsnag, BugsnagErrorBoundary }
